import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { getColumnString } from '../../common'
import { nullish, nullishValueToValue } from '../ArticleParse'
import { Article } from '../types'

type Props = { article: Article }

export const SizedArticleArea = ({ article }: Props) => {
  const yPosValue = nullishValueToValue(article?.areas?.[0]?.y)
  const xPosValue = nullishValueToValue(article?.areas?.[0]?.x)
  const heightValue = getColumnString(String(article?.areas?.[0]?.height ?? '')) || ''
  const widthValue = article?.areas?.[0]?.width || ''
  const rowsValue = article?.rows || ''

  const yPosStr = !nullish(yPosValue) ? `天から${yPosValue}段目` : null
  const xPosStr = !nullish(xPosValue) ? `右から${xPosValue}行目` : null
  const hStr = !nullish(heightValue) ? `高さ${heightValue}` : null
  const wStr = !nullish(widthValue) ? `横幅${parseInt(String(widthValue))}行` : null
  const rStr = !nullish(rowsValue) ? `行数指定${rowsValue}行` : null

  const values = [yPosStr, xPosStr, hStr, wStr, rStr].filter((s) => s !== null)

  if (values.length === 0) {
    return ''
  }
  return (
    <OverlayTrigger
      key={`article-${article.id}-size-overlay`}
      placement='auto'
      overlay={(props) => <Tooltip {...props}>{values.join(' ')}</Tooltip>}
    >
      <Badge bg='secondary'>位置・サイズ</Badge>
    </OverlayTrigger>
  )
}
